import type { SVGProps } from "react";
export default function SvgDueDiligenceApp(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 163 188"
			{...props}
		>
			<foreignObject width={163} height={190.268} x={0} y={-2.83398}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_0_1094_1392_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter0_ddddi_1094_1392)">
				<path
					fill="url(#paint0_linear_1094_1392)"
					fillOpacity={0.6}
					d="M80.157 16.148a2.11 2.11 0 0 1 2.686 0 54.8 54.8 0 0 0 35.867 12.568c.921-.016 1.754.571 1.989 1.462a54.6 54.6 0 0 1-5.315 40.858 54.7 54.7 0 0 1-14.301 16.418 54.8 54.8 0 0 1-19.082 9.414 1.9 1.9 0 0 1-1.002 0 54.8 54.8 0 0 1-19.081-9.414 54.7 54.7 0 0 1-14.302-16.418A54.6 54.6 0 0 1 42.3 30.178c.235-.891 1.069-1.478 1.99-1.462a54.8 54.8 0 0 0 35.866-12.568"
				/>
				<path
					stroke="url(#paint1_linear_1094_1392)"
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M80.157 16.148a2.11 2.11 0 0 1 2.686 0 54.8 54.8 0 0 0 35.867 12.568c.921-.016 1.754.571 1.989 1.462a54.6 54.6 0 0 1-5.315 40.858 54.7 54.7 0 0 1-14.301 16.418 54.8 54.8 0 0 1-19.082 9.414 1.9 1.9 0 0 1-1.002 0 54.8 54.8 0 0 1-19.081-9.414 54.7 54.7 0 0 1-14.302-16.418A54.6 54.6 0 0 1 42.3 30.178c.235-.891 1.069-1.478 1.99-1.462a54.8 54.8 0 0 0 35.866-12.568"
				/>
			</g>
			<foreignObject width={126.556} height={139.37} x={18.2227} y={23.0752}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_1_1094_1392_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter1_ddddi_1094_1392)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="M104.278 56.76Q95.168 71.946 81.5 71.946q-13.665 0-22.777-15.186 9.11-15.185 22.777-15.185t22.778 15.185"
				/>
				<path
					stroke="url(#paint2_linear_1094_1392)"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeOpacity={0.5}
					d="M104.278 56.76Q95.168 71.946 81.5 71.946q-13.665 0-22.777-15.186 9.11-15.185 22.777-15.185t22.778 15.185"
				/>
			</g>
			<path
				fill="#FAFF00"
				d="M76.439 56.76a5.062 5.062 0 1 0 10.124 0 5.062 5.062 0 0 0-10.124 0"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1094_1392"
					x1={81.7091}
					x2={81.7091}
					y1={15}
					y2={97}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1094_1392"
					x1={81.5}
					x2={51.2232}
					y1={15.898}
					y2={83.1823}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1094_1392"
					x1={81.5004}
					x2={81.5004}
					y1={41.5752}
					y2={71.9456}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<clipPath id="bgblur_0_1094_1392_clip_path" transform="translate(0 2.834)">
					<path d="M80.157 16.148a2.11 2.11 0 0 1 2.686 0 54.8 54.8 0 0 0 35.867 12.568c.921-.016 1.754.571 1.989 1.462a54.6 54.6 0 0 1-5.315 40.858 54.7 54.7 0 0 1-14.301 16.418 54.8 54.8 0 0 1-19.082 9.414 1.9 1.9 0 0 1-1.002 0 54.8 54.8 0 0 1-19.081-9.414 54.7 54.7 0 0 1-14.302-16.418A54.6 54.6 0 0 1 42.3 30.178c.235-.891 1.069-1.478 1.99-1.462a54.8 54.8 0 0 0 35.866-12.568" />
				</clipPath>
				<clipPath id="bgblur_1_1094_1392_clip_path" transform="translate(-18.223 -23.075)">
					<path d="M104.278 56.76Q95.168 71.946 81.5 71.946q-13.665 0-22.777-15.186 9.11-15.185 22.777-15.185t22.778 15.185" />
				</clipPath>
				<filter
					id="filter0_ddddi_1094_1392"
					width={163}
					height={190.268}
					x={0}
					y={-2.83398}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1094_1392" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1094_1392"
						result="effect2_dropShadow_1094_1392"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1094_1392"
						result="effect3_dropShadow_1094_1392"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1094_1392"
						result="effect4_dropShadow_1094_1392"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1094_1392" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1094_1392" />
				</filter>
				<filter
					id="filter1_ddddi_1094_1392"
					width={126.556}
					height={139.37}
					x={18.2227}
					y={23.0752}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1094_1392" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1094_1392"
						result="effect2_dropShadow_1094_1392"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1094_1392"
						result="effect3_dropShadow_1094_1392"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1094_1392"
						result="effect4_dropShadow_1094_1392"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1094_1392" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1094_1392" />
				</filter>
			</defs>
		</svg>
	);
}
